import { render } from "./role.vue?vue&type=template&id=6bea60fb&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=6bea60fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bea60fb"

export default script